import * as React from "react";

function SvgAutoModeTop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="matrix(3.768786,0,0,3.768786,-0.00381647,-1079.4463)">
        <g transform="matrix(0.26458333,0,0,0.26458333,0.00137839,286.41782)" fill="none">
          <circle cx={20} cy={20} r={19.5} stroke="#fff" />
        </g>
        <g transform="matrix(0.26458333,0,0,0.26458333,1.8534584,288.19935)" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 3.33333,2.59998 H 2.66667 L 0,12.6 H 1.33333 L 1.66667,11.2666 H 4.33333 L 4.66667,12.6 H 6 Z M 2,9.93331 3,5.59998 4,9.93331 Z M 6.66667,2.59998 H 8 V 10.6 l 0.66667,0.6666 H 10.6667 L 11.3333,10.6 V 2.59998 h 1.3334 V 11.2666 L 11.3333,12.6 H 8 L 6.66667,11.2666 Z m 18.00003,0 H 23 21.3333 L 20.6667,3.26664 20,3.93331 V 11.2666 L 21.3333,12.6 h 3.3334 L 26,11.2666 V 3.93331 L 25.3333,3.26664 Z m -3.3334,2 L 22,3.93331 h 2 l 0.6667,0.66667 V 10.6 L 24,11.2666 H 22 L 21.3333,10.6 Z M 9.66667,13.9333 H 11.3333 L 12,14.6 12.6667,15.2666 V 22.6 l -1.3334,1.3333 H 8 L 6.66667,22.6 V 15.2666 L 7.33333,14.6 8,13.9333 Z m -1,1.3333 L 8,15.9333 v 6 L 8.66667,22.6 h 2.00003 l 0.6666,-0.6667 v -6 L 10.6667,15.2666 Z M 15,3.93331 h 0.6667 V 4.59998 11.9333 12.6 H 16.3333 17 V 11.9333 4.59998 3.93331 h 0.6667 1 0.6666 V 3.26664 2.59998 H 18.6667 14 13.3333 V 3.26664 3.93331 H 14 Z M 0,13.9333 h 1.33333 l 1.66667,2 1.66667,-2 H 6 v 10 H 4.66667 v -8 l -1.66667,2 -1.66667,-2 v 8 H 0 Z m 13.3333,0 v 10 H 18 L 19.3333,22.6 V 15.2666 L 18,13.9333 Z m 1.3334,1.3333 h 2.6666 L 18,15.9333 v 6 L 17.3333,22.6 H 14.6667 Z M 20,13.9333 v 10 h 6 V 22.6 H 21.3333 V 19.2666 H 26 V 17.9333 H 21.3333 V 15.2666 H 26 v -1.3333 z"
            fill="#fff"
          />
        </g>
      </g>
      
    </svg>
  );
}

export default SvgAutoModeTop;
